import type { R2Index } from '../../layerstack/LayerStackLoader';
import type { BandSpec } from '../R2Renderer';
import { rtPath } from '../assets/registry';

/**
 * The sparse landmark row that sits between the middle and near bands.
 *
 * PROVISIONAL placement: speed 0.20, one copy every 2880 logical px, top edge
 * at y=96. None of the three numbers is measured against the art — they are a
 * first reading that keeps the landmark clear of the near band's skyline and
 * rare enough to read as a landmark rather than a fourth parallax row. It wraps
 * by repeat, not mirror: a landmark that ping-pongs would read as two.
 */
const LANDMARK_SLUG = '04-stage1-landmark';
const LANDMARK_SPEED = 0.2;
const LANDMARK_SPAN = 2880;
const LANDMARK_TOP_Y = 96;

export function landmarkBandSpec(index: R2Index): BandSpec {
  return {
    rungPath: rtPath(index, LANDMARK_SLUG),
    speed: LANDMARK_SPEED,
    y: LANDMARK_TOP_Y,
    spanWidth: LANDMARK_SPAN,
  };
}
